export const CRASH_ERROR_HEAD = "There's a problem loading this page";
export const CRASH_ERROR_SUBTEXT = `There's a technical problem with Einteger that has prevented
this page from loading. Try reloading this page or going to another page.`;
